"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var style = props.style,
      className = props.className,
      children = props.children,
      span = props.span;

  if (span) return _react2.default.createElement(
    "span",
    { className: className, style: _extends({ display: "block" }, style) },
    children
  );

  return _react2.default.createElement(
    "div",
    { className: className, style: style },
    children
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/SpanOrDiv.js
// module id = 84
// module chunks = 0